import React, { useEffect, useState, createContext, useContext } from 'react';
// Mock user data
const mockUsers = [{
  id: 1,
  name: 'John Doe',
  email: 'john@example.com',
  password: 'password123',
  phone: '+1 (555) 123-4567',
  memberSince: 'January 2023'
}];
// Define the auth context type
type AuthContextType = {
  user: any | null;
  login: (email: string, password: string) => boolean;
  register: (name: string, email: string, password: string) => boolean;
  logout: () => void;
  isAuthenticated: boolean;
};
// Create the context
const AuthContext = createContext<AuthContextType | undefined>(undefined);
// Auth provider component
export const AuthProvider = ({
  children
}) => {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  // Check for saved user on initial load
  useEffect(() => {
    const savedUser = localStorage.getItem('user');
    if (savedUser) {
      try {
        const parsedUser = JSON.parse(savedUser);
        setUser(parsedUser);
        setIsAuthenticated(true);
      } catch (error) {
        console.error('Error parsing saved user:', error);
        localStorage.removeItem('user');
      }
    }
  }, []);
  // Login function
  const login = (email: string, password: string) => {
    // Find user with matching email and password
    const foundUser = mockUsers.find(u => u.email.toLowerCase() === email.toLowerCase() && u.password === password);
    if (foundUser) {
      // Create a copy without the password
      const {
        password,
        ...userWithoutPassword
      } = foundUser;
      setUser(userWithoutPassword);
      setIsAuthenticated(true);
      localStorage.setItem('user', JSON.stringify(userWithoutPassword));
      return true;
    }
    return false;
  };
  // Register function
  const register = (name: string, email: string, password: string) => {
    // Check if email already exists
    const existingUser = mockUsers.find(u => u.email.toLowerCase() === email.toLowerCase());
    if (existingUser) {
      return false;
    }
    // Create new user
    const newUser = {
      id: mockUsers.length + 1,
      name,
      email,
      password,
      memberSince: new Date().toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long'
      })
    };
    // Add to mock users (in a real app, this would be an API call)
    mockUsers.push(newUser);
    // Login the user
    const {
      password: _,
      ...userWithoutPassword
    } = newUser;
    setUser(userWithoutPassword);
    setIsAuthenticated(true);
    localStorage.setItem('user', JSON.stringify(userWithoutPassword));
    return true;
  };
  // Logout function
  const logout = () => {
    setUser(null);
    setIsAuthenticated(false);
    localStorage.removeItem('user');
  };
  return <AuthContext.Provider value={{
    user,
    login,
    register,
    logout,
    isAuthenticated
  }} data-id="element-627">
      {children}
    </AuthContext.Provider>;
};
// Custom hook to use the auth context
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};